import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Modal, Table} from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';

class ModalGpoRh extends Component{
	constructor(props){
		super(props);
	
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			groups:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(item){
		this.setState({show:true, groups:item});
	}

	handleClose(){
		this.setState({show:false, groups:[]});
	}

	render(){
		const {t} = this.props;

		return (
			<Modal bsSize="sm" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Grupos Discrepantes</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 col-sm-9 col-sm-offset-2">
		        			<Table>
		        				<thead>
		        					<tr>
		        						<th>Grupo & RH</th>
		        						<th>Muestras</th>
		        					</tr>
		        				</thead>
		        				<tbody>
		        					{this.state.groups.map((gpo, i)=>(
										
										<tr key={i}>
											<td>
												{(gpo.group === null ? '' : gpo.group)+
												(gpo.rh === 'POSITIVO' ? '+' :
												gpo.rh === 'NEGATIVO' ? '-' : '')}
											</td>
											<td>
												{gpo.samples.map((s, j)=>(
													<div key={j}>
														{s.number}
													</div>
												))}
											</td>
										</tr>
										
									))}
		        				</tbody>
		        			</Table>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}

}

export default translate('translations')(ModalGpoRh)